import api from "../../../../../api/api"


const getByVoucherId = (voucherId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/voucher-in-item/"+voucherId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const save = (payload) => {
    return new Promise((resolve, reject) => {
        // Pointing to voucher-in-item endpoint
        api.post("erp/voucher-in-item", payload).then((res) => {
            if (!res.data.error) {
                resolve(res.data);
            } else {
                reject({ msg: res.data.msg });
            }
        }).catch((error) => {
            reject({ msg: "Something Went Wrong", error });
        });
    });
};

const remove = (id) => {
    return new Promise((resolve, reject) => {
        api.delete("erp/voucher-in-item/" + id).then((res) => {
            if (!res.data.error) {
                resolve(res);
            } else {
                reject({ msg: res.data.msg });
            }
        }).catch((error) => {
            reject({ msg: "Something Went Wrong", error });
        });
    });
};

const voucherInItemServices = {
    getByVoucherId,
    save,
    remove,
};

export default voucherInItemServices;